import { ErrorComponentProps } from '@ferreri/minato-error-handler-react';
import {
  HelpIllustration,
  ModalFullScreen,
  useOriginUrl,
} from '@ferreri/prever-component-lib';

export const InvalidCouponError = ({
  error,
  hideError,
}: ErrorComponentProps) => {
  const baseUrl = useOriginUrl();
  const planHref = `${baseUrl}/plan`;

  const handleClick = () => {
    document.location.assign(planHref);
    hideError();
  };

  return (
    <ModalFullScreen
      title="Cupom inválido"
      description="Cupom indisponível ou com dados incorretos."
      illustration={<HelpIllustration />}
      labelButtonPrimary="Prosseguir sem cupom"
      onClickButtonPrimary={handleClick}
      error={error}
    />
  );
};
